<div class="modal-size" role="dialog">
  <gstar-header-modal
    [id]="modalId()"
    (cancel)="closeHandler()"
    [title]="'admin.dashboard.exportTaxRateValues' | translate" />
  <gstar-body-modal>
    <p>
      {{ 'admin.dashboard.exportTaxRateValuesConfirmation' | translate }}
    </p>
  </gstar-body-modal>
  <gstar-footer-modal
    [id]="modalId()"
    (confirmEvent)="confirm()"
    (cancelEvent)="closeHandler()" />
</div>
